// extracted by mini-css-extract-plugin
export default {"deletePopconfirm":"WordsActionRow_deletePopconfirm__ZFQqt"};